import gql from 'graphql-tag'

export default gql `
  mutation deleteExport{
    deleteExport{
        id
    }
  }
`